import { IResponseProcessor } from "..";
import { Job as ApiJob } from "randmar-api-client";

/**
 * @deprecated This legacy API class should be replaced by RTK Query hooks from randmar-api-client.
 * Specifically, use the `useGetV4PartnerByRouteApplicationIdJobsQuery` hook.
 */
export default class JobsApi {
  constructor(
    private _baseUrl: string,
    private _getToken: () => string,
    private _processor: IResponseProcessor
  ) { }

  async retrieveJobs(applicationId: string): Promise<IJob[]> {
    const res = await fetch(`${this._baseUrl}/Partner/${applicationId}/Jobs`, {
      headers: { Authorization: `Bearer ${this._getToken()}` }
    });

    this._processor.process(res);

    const data: IJob[] = await res.json();

    return data;
  }
}

/**
 * @deprecated Use `Job` from `randmar-api-client` instead. Note that property names are PascalCase in the new type.
 */
export interface IJob {
  header: IJobHeader;
  body?: unknown;
  internalComments?: string | null;
}

/**
 * @deprecated Use `JobHeader` from `randmar-api-client` instead. Note that property names are PascalCase in the new type.
 */
export interface IJobHeader {
  applicationId: string;
  createdAt: number;
  description: string;
  status: string;
  fileNames: string[];
  jobId: string;
  type: string;
  comment?: string | null;
  logs?: string[] | null;
}

/**
 * Converts a job object from the new API format (PascalCase) to the legacy `IJob` format (camelCase).
 * This utility function supports the gradual migration of components.
 * @param apiJob The job object from `randmar-api-client`.
 * @returns The job object in the legacy `IJob` format.
 */
export const convertApiJobToLegacyJob = (apiJob: ApiJob): IJob => {
  const { Header: header, Body: body, InternalComments: internalComments } = apiJob;
  return {
    header: {
      applicationId: header?.ApplicationId ?? "",
      createdAt: header?.CreatedAt ?? 0,
      description: header?.Description ?? "",
      status: header?.Status ?? "",
      fileNames: header?.FileNames ?? [],
      jobId: header?.JobId ?? "",
      type: header?.Type ?? "",
      comment: header?.Comment,
      logs: header?.Logs,
    },
    body,
    internalComments,
  };
};

/**
 * Converts a job object from the legacy `IJob` format (camelCase) to the new API format (PascalCase).
 * This utility function supports the gradual migration of components.
 * @param legacyJob The job object in the legacy `IJob` format.
 * @returns The job object in the `randmar-api-client` `Job` format.
 */
export const convertLegacyJobToApiJob = (legacyJob: IJob): ApiJob => {
  const { header, body, internalComments } = legacyJob;
  return {
    Header: {
      ApplicationId: header.applicationId,
      CreatedAt: header.createdAt,
      Description: header.description,
      Status: header.status,
      FileNames: header.fileNames,
      JobId: header.jobId,
      Type: header.type,
      Comment: header.comment,
      Logs: header.logs,
    },
    Body: body,
    InternalComments: internalComments,
  };
};
